import request from '@/utils/request'

/**
 * 动态列表
 * type 1.选课 2.报送 3.资源库 null全部
 * keyword 关键字查询
 * state  1.未开始 2.进行中 3.已结束
 * mydata 1.是 0.否
 */
export function dynamic(data) {
    return request({
        url: '/client/dynamic.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
export function menutop(data) {
    return request({
        url: '/client/function.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
export function bannerList(data) {
    return request({
        url: '/setting/index/getBanner.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
export function editBanner(data) {
    return request({
        url: '/setting/index/banner.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
export function schoolInfoModify(data) {
    return request({
        url: '/setting/basicSet/schoolInfoModify.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
export function helpCenterList(data) {
    return request({
        url: '/setting/index/helpCenterList.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

export function helpCenterModify(data) {
    return request({
        url: '/setting/index/helpCenterModify.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
export function schoolInfo(data) {
    return request({
        url: '/setting/basicSet/schoolInfo.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 课程列表
 */
export function manageLessonList(data) {
    return request({
        url: '/wechat/newXuanke/manageLessonList.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 课程选课情况
 */
export function listManageLessonStudent(data) {
    return request({
        url: '/wechat/newXuanke/listManageLessonStudent.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 计划班级列表
 */
export function listSelectLessonSchoolClasses(data) {
    return request({
        url: '/wechat/newXuanke/listSelectLessonSchoolClasses.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 选课班级学生列表
 */
export function listSchoolClassesXuanKeStudent(data) {
    return request({
        url: '/wechat/newXuanke/listSchoolClassesXuanKeStudent.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 学科列表
 */
export function listResourceSubject(data) {
    return request({
        url: '/resource/listResourceSubject.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 资源类列表
 */
export function listResourceType(data) {
    return request({
        url: '/resource/listResourceType.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 标签列表
 */
export function listLabel(data) {
    return request({
        url: '/resource/listLabel.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 浏览量
 */
export function browseCount(data) {
    return request({
        url: '/www/resource/browseCount?id=' + data.id,
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 下载量
 */
export function downloadCount(data) {
    return request({
        url: '/www/resource/downloadCount.ajax?id=' + data.id,
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 当前版本信息
 */
export function presentVersion() {
    return request({
        url: '/base/presentVersion.ajax?moduleId=4',
        method: 'get',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },

    })
}
/**
 * 项目详情
 */
export function submitProjectDetail(data) {
    return request({
        url: '/submit/submitProjectDetail.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 根据项目id获取模板字段
 */
export function listSubmitProjectField(data) {
    return request({
        url: '/submit/listSubmitProjectField.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 新增或编辑记录
 */
export function modifySubmitProjectData(data) {
    return request({
        url: '/submit/modifySubmitProjectData.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 获取提交信息
 */
export function submitProjectDataDetail(data) {
    return request({
        url: '/submit/submitProjectDataDetail.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 更新记录状态
 */
export function updateProjectDataState(data) {
    return request({
        url: '/submit/updateProjectDataState.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 个人信息
 */
export function userinfo(data) {
    return request({
        url: '/index/userinfo.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 统计数据
 */
export function statistics(data) {
    return request({
        url: '/client/statistics.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 账号信息设置
 */
export function modifyUserAccount(data) {
    return request({
        url: '/setting/userSet/modifyUserAccount.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 用户信息保存
 */
export function modifyUserInfo(data) {
    return request({
        url: '/setting/userSet/modifyUserInfo.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 教师信息保存
 */
export function modifyUserInfoTeacher(data) {
    return request({
        url: '/setting/userSet/modifyUserInfoTeacher.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 班主任信息保存
 */
export function modifySchoolClassesHeadmaster(data) {
    return request({
        url: '/setting/userSet/modifySchoolClassesHeadmaster.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 头像保存
 */
export function modifyImg(data) {
    return request({
        url: '/setting/personalSet/modifyImg.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 修改密码
 */
export function modifyPwd(data) {
    return request({
        url: '/setting/personalSet/modifyPwd.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * 我的权限
 */
export function myAuth(data) {
    return request({
        url: '/setting/systemSet/myAuth.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}
/**
 * logo
 */
export function getModifySchoolLoginPage(data) {
    return request({
        url: '/setting/personalizeSet/getModifySchoolLoginPage.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * logo
 */
export function uploadHeadImage(data) {
    return request({
        url: '/setting/personalSet/uploadHeadImage.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 获取我的周的课表
 */
export function myLessonTable(data) {
    return request({
        url:  '/wechat/adjust/myLessonTable.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 获取当前学期
 */
export function listSchoolSemester(data) {
    return request({
        url:  '/setting/basicSet/listSchoolSemester.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}



/**
 * 获取周列表
 */
export function getWeekList(data) {
    return request({
        url:  '/adjustLesson/getWeekList.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 获取周列表
 */
export function myAdjustCourse(data) {
    return request({
        url:  '/client/myAdjustCourse.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 获取当月调课代课次数
 */
export function listData(data) {
    return request({
        url:  '/adjustLesson/listData.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 调代课审核
 */
export function updateStatus(data) {
    return request({
        url:  '/wechat/adjust/updateStatus.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 获取可调课表
 */
export function exchangeLessonTable(data) {
    return request({
        url:  '/wechat/adjust/exchangeLessonTable.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}



/**
 * 申请调课按钮
 */
export function applyChange(data) {
    return request({
        url:  '/wechat/adjust/applyChange.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}



/**
 * 成绩上传返回绑定数据
 */
export function getHeader(data) {
    return request({
        url:  '/query/excel/getHeader.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 获取成绩单字段类型
 */
export function getDic(data) {
    return request({
        url:  '/query/excel/getDic.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 获取成绩数据插入临时表
 */
export function importExcel(data) {
    return request({
        url:  '/query/excel/importExcel.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 获取成绩单临时表
 */
export function getTranscriptExcel(data) {
    return request({ 
        url:  '/query/excel/getTranscriptExcel.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 成绩单临时表数据更新
 */
export function updateExcel(data) {
    return request({ 
        url:  '/query/excel/updateExcel.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 成绩单临时表数据删除
 */
export function detelExcel(data) {
    return request({ 
        url:  '/query/excel/detelExcel.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}



/**
 * 导出成绩单数据
 */
export function excelExport(data) {
    return request({
        url:  '/query/excel/export.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 成绩单导入正式表
 */
export function importDate(data) {
    return request({
        url:  '/query/excel/importDate.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 成绩单查询列表
 */
export function scoreQueryList(data) {
    return request({
        url:  '/query/score/scoreQueryList.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 成绩单删除
 */
export function scoreDelete(data) {
    return request({
        url:  '/query/score/delete.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 成绩单导出
 */
export function scoreExport(data) {
    return request({
        url:  '/query/score/export.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * 成绩单修改成绩单正式数据
 */
export function scoreUpdate(data) {
    return request({
        url:  '/query/score/update.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 成绩单修改成绩单正式数据
 */
export function deleteQuery(data) {
    return request({
        url:  '/query/score/deleteQuery.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 修改成绩单标题
 */
export function updateTranscript(data) {
    return request({
        url:  '/query/score/updateTranscript.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * （无登录版）列表头获取
 */
export function getNotLoginHeader(data) {
    return request({
        url:  '/query/excel/getNotLoginHeader.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * (无登录版)数据插入
 */
export function notLoginimport(data) {
    return request({
        url:  '/query/excel/import.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * (无登录版)数据获取
 */
export function getNotLoginList(data) {
    return request({
        url:  '/query/score/getNotLoginList.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * (无登录版)批量删除功能
 */
export function delNotLoginData(data) {
    return request({
        url:  '/query/score/delNotLoginData.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

/**
 * (无登录版)批量导出
 */
export function notLoginExport(data) {
    return request({
        url:  '/query/score/notLoginExport.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * (无登录版)修改数据
 */
export function updateValue(data) {
    return request({
        url:  '/query/excel/updateValue.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * (无登录版)启用销毁
 */
export function updateState(data) {
    return request({
        url:  '/query/score/updateState.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 发送验证码
 */
export function sendMsg(data) {
    return request({
        url:  '/wechat/index/sendMsg.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 手机验证码登录
 */
export function loginByPhoneCode(data) {
    return request({
        url:  '/wechat/index/loginByPhoneCode',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 修改密码 验证码验证
 */
export function updataValidate(data) {
    return request({
        url:  '/wechat/index/updataValidate.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


/**
 * 修改密码
 */
export function updataPasswordByPhone(data) {
    return request({
        url:  '/user/updataPasswordByPhone.ajax',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}


//获取当前登录人的版本
export function findCurrentVersion(data) {
    return request({
        url:  '/salesVersions/findCurrentVersion.json',
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json; charset=UTF-8'
        // },
        data: data
    })
}

